import React from 'react';
import './index.css';

const DataListHead = (props) => {
	return (
		<div className={`data-list__head d-flex no-gutters${props.className ? ' ' +props.className : ''} align-items-center border-bottom`}>
			{props.children}
		</div>
	)
};

export default DataListHead;